import { Routes, Route } from 'react-router-dom';
import React from 'react';

// Layout Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ListingsPage from './pages/ListingsPage';
import ListingDetailPage from './pages/ListingDetailPage';
import CreateListingPage from './pages/CreateListingPage';
import ManageListingsPage from './pages/ManageListingsPage';
import EditListingPage from './pages/EditListingPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import UploadCertificatePage from './pages/UploadCertificatePage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ManageRequestsPage from './pages/ManageRequestsPage';
import DonorRequestsPage from './pages/DonorRequestsPage';
import RequestDetailPage from './pages/RequestDetailPage';
import NotificationsPage from './pages/NotificationsPage';
import NotFoundPage from './pages/NotFoundPage';
import UserDetailView from './components/UserDetailView';

// Context
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="listings" element={<ListingsPage />} />
            <Route path="listings/:id" element={<ListingDetailPage />} />
            <Route 
              path="create-listing" 
              element={
                <ProtectedRoute requiredRole="donor">
                  <CreateListingPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="listings/manage" 
              element={
                <ProtectedRoute requiredRole="donor">
                  <ManageListingsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="upload-certificate" 
              element={
                <ProtectedRoute requiredRole="donor">
                  <UploadCertificatePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="listings/edit/:id" 
              element={
                <ProtectedRoute requiredRole="donor">
                  <EditListingPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected routes */}
            <Route 
              path="dashboard/*" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="profile" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="admin" 
              element={
                <ProtectedRoute requiredRole="admin" redirectPath="/dashboard">
                  <AdminDashboardPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="admin/users/:userId" 
              element={
                <ProtectedRoute requiredRole="admin" redirectPath="/dashboard">
                  <UserDetailView />
                </ProtectedRoute>
              } 
            />
            
            {/* Notifications route */}
            <Route 
              path="notifications" 
              element={
                <ProtectedRoute>
                  <NotificationsPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Request management routes */}
            <Route 
              path="requests/manage" 
              element={
                <ProtectedRoute requiredRole="recipient">
                  <ManageRequestsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="requests/donor" 
              element={
                <ProtectedRoute requiredRole="donor">
                  <DonorRequestsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="requests/:id" 
              element={
                <ProtectedRoute>
                  <RequestDetailPage />
                </ProtectedRoute>
              } 
            />
            
            {/* 404 route */}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
